import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    padding: 20px 0px;
    font-size: 9px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.3);

    display: flex;
    align-items: center;
    justify-content: space-between;

    h1{
        margin-left: 15px;

        span{
            @media (max-width: 800px){
                 margin-left: 10px;
            }
        }
    }

    svg{
        margin-right: 20px;
        font-size: 20px;
        color: gray;

        @media (max-width: 800px){
            margin-right: 5px;
        }

        @media (min-width: 800px){
            cursor: pointer;
        }
    }

    @media (max-width: 800px){
            .icon{
                margin-right: 15px;
            }
    }

    h1{
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .icons-container{
        margin: 0;
        display: flex;
    }

    .seeMore{
        display: flex;
        flex-direction: column;
        color: var(--colorFontsCardsDashboard);

        @media (min-width: 960px){
            cursor: pointer;
        }
    }

    .button-excel-container{
        position: absolute;
        top: 40px;
        right: 40px;
        z-index: 99;
        gap: 0.5rem;
        background-color: #fff;
        padding: 1rem;
        border-radius: 5px;
        box-shadow: 0 2px 4px rgb(0 0 0 / 10%), 0 8px 16px rgb(0 0 0 / 10%);

        button{
            border: 1px solid #237344;
            border-radius: 0.2rem;
            background: none;
            color: #237344;
            padding: 0.5rem 1.5rem;
            font-size: 0.9rem;

            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
`